// extracted by mini-css-extract-plugin
export var form = "style-module--form--2mMSd";
export var form_email = "style-module--form_email--2buTi";
export var form_email_input = "style-module--form_email_input---T5zz";
export var form_accept = "style-module--form_accept--QGp96";
export var form_submit = "style-module--form_submit--2edu1";
export var form_submit_btn = "style-module--form_submit_btn--3Po8r";